import Index from '@/views/user-transactions/index'
import Form from '@/views/user-transactions/form'

const model = 'Transaction'
export default [
  {
    path: '/users/:userId/transactions',
    name: 'userTransactions',
    component: Index,
    meta: { requiresAuth: true, auth: { model, permission: 'read' } }
  },
  {
    path: '/users/:userId/transactions/new',
    name: 'newUserTransaction',
    component: Form,
    meta: { requiresAuth: true, auth: { model, permission: 'create' } }
  }
]
